<template lang="pug">
v-simple-table(dense)
  thead
    tr
      th Date
      th.text-right Amount
  tbody
    tr(v-for="(item, index) in purchases", :key="index")
      td {{ item.created | datetime }}
      td.text-right {{ (item.amount / 100) | currency }}
        span.ml-1.text-uppercase {{ item.currency }}
</template>

<script>
export default {
  props: ["purchases"],
};
</script>